// src/UI/Select/Select.tsx
import React, { FC, ReactNode } from "react";
import { StyledSelect } from "./styles.ts";
import selectTokens from "./selectTokens.ts";

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  /** Размер селекта по дизайн-токенам: S, M или L */
  size?: "S" | "M" | "L"|"F";
  /** Дочерние элементы (обычно <option>...) */
  children?: ReactNode;
}

/**
 * Компонент Select — переиспользуемый селект
 * с токенами из selectTokens и стилизованным StyledSelect.
 */
const Select: FC<SelectProps> = ({
  size = "M",
  disabled = false,
  children,
  radius = "regular", 
  ...props
}) => {
  const { height, fontSize, paddingX, gap } = selectTokens.sizes[size] || selectTokens.sizes.M;
  const borderRadius =
  selectTokens.borderRadius[radius] ?? selectTokens.borderRadius.regular;

  return (
    <StyledSelect
      disabled={disabled}
      $height={height}
      $fontSize={fontSize}
      $paddingX={paddingX}
      $gap={gap}
      $borderRadius={borderRadius}
      {...props}
    >
      {children}
    </StyledSelect>
  );
};

export default Select;

